// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPage_page__AWUpd","container":"PrivacyPage_container__n7NC+","intro":"PrivacyPage_intro__Ovu+f","footer":"PrivacyPage_footer__vUpwX"};